import React from "react";
import { TextField } from "@mui/material";
import {
  AsYouType,
  CountryCode,
} from "libphonenumber-js";
import { isSupportedCountry } from "react-phone-number-input";

interface PhoneNumberInputFieldProps {
  label: string;
  value?: string;
  defaultCountryCode?: string;
  readOnly?: boolean;
  required?: boolean;
  maxLength?: number;
  placeholder?: string;
  testId?: string;
  onChange?: (value: string) => void;
}

const createHandleChange =
  (onChange?: (value: string) => void, defaultCountryCode?: string) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;

      const validCountry = isSupportedCountry(defaultCountryCode || "")
        ? (defaultCountryCode as CountryCode)
        : undefined;

      const formatter = new AsYouType(validCountry);
      const formatted = formatter.input(raw);

      onChange?.(formatted);
    };

const PhoneNumberInputField: React.FC<PhoneNumberInputFieldProps> = ({
  label,
  value = "",
  defaultCountryCode,
  readOnly = false,
  required = false,
  maxLength,
  placeholder,
  testId,
  onChange,
}) => {
  const handleChange = React.useMemo(
    () => createHandleChange(onChange, defaultCountryCode),
    [onChange, defaultCountryCode]
  );

  return (
    <TextField
      data-testid={testId}
      label={label}
      disabled={readOnly}
      required={required}
      value={value}
      onChange={handleChange}
      inputProps={{ maxLength }}
      placeholder={placeholder}
      fullWidth
      variant="outlined"
      size="small"
    />
  );
};

export default PhoneNumberInputField;
